import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'SEALING_INSPECTION_VALUE_LIST',
    method: 'GET',
  });

  useEffect(() => {
    if (params) {
      let url = `/api/sealing/inspection/sample`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  //console.error('GETmain==>', JSON.stringify(data));
  return [isRequestSuccessed, data || [], exec];
  // }
});
